import { getAuth } from "firebase/auth";
import { createRouter, createWebHistory } from "vue-router";
import BasicLayout from "../layouts/BasicLayout.vue";
import BillingLayout from "../layouts/BillingLayout.vue";
import GuestLayout from "../layouts/GuestLayout.vue";
import TicketingLayout from "../layouts/TicketingLayout.vue";
import Billing from "../views/Billing.vue";
import BillingHistory from "../views/BillingHistory.vue";
import BillingInfo from "../views/BillingInfo.vue";
import Config from "../views/Config.vue";
import ForgotPasswordVue from "../views/ForgotPassword.vue";
import GuestPayment from "../views/GuestPayment.vue";
import Login from "../views/Login.vue";
import OpenItems from "../views/OpenItems.vue";
import RequestAccess from "../views/RequestAccess.vue";
import TicketingCreate from "../views/TicketingCreate.vue";
import TicketingDetail from "../views/TicketingDetail.vue";
import TicketingList from "../views/TicketingList.vue";
import Welcome from "../views/Welcome.vue";
import Onboarding from "../views/Onboarding.vue";
import { auth, guest } from "./middleware";
import {
    getCurrentStepRoutePath,
    loadOnboardingProgressFromBackend,
    onboardingProgress,
    isOnboardingEnabled,
    isOnboardingInProgress,
} from "../constants/onboardingProgress";

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            beforeEnter: guest,
            component: GuestLayout,
            path: "/login",
            children: [
                {
                    path: "",
                    component: Login,
                },
            ],
        },
        {
            component: GuestLayout,
            path: "/request-access",
            children: [
                {
                    path: "",
                    component: RequestAccess,
                },
            ],
        },
        {
            component: GuestLayout,
            path: "/forgot-password",
            children: [
                {
                    path: "",
                    component: ForgotPasswordVue,
                },
            ],
        },
        {
            path: "/payment",
            component: BasicLayout,
            children: [
                {
                    path: ":id",
                    component: GuestPayment,
                },
            ],
        },
        {
            path: "/",
            beforeEnter: auth,
            component: BasicLayout,
            redirect: "home",
            children: [
                {
                    beforeEnter: auth,
                    path: "home",
                    component: Welcome,
                },
                {
                    beforeEnter: auth,
                    path: "onboarding",
                    component: Onboarding,
                },
                {
                    beforeEnter: auth,
                    path: "open-items",
                    component: OpenItems,
                },

                //DEPRECATED ROUTES
                {
                    beforeEnter: auth,
                    path: "ticketing",
                    component: TicketingLayout,
                    children: [
                        {
                            path: "",
                            component: TicketingList,
                        },
                        {
                            path: ":ticketId",
                            component: TicketingDetail,
                        },
                        {
                            path: "new",
                            component: TicketingCreate,
                        },
                    ],
                },
                {
                    path: "billing",
                    component: BillingLayout,
                    children: [
                        {
                            path: "",
                            component: Billing,
                        },
                        {
                            path: "history",
                            component: BillingHistory,
                        },
                        {
                            path: "info",
                            component: BillingInfo,
                        },
                    ],
                },
                {
                    beforeEnter: auth,
                    path: "config",
                    component: Config,
                },
            ],
        },
        // Catch-all route for 404 Not Found
        {
            path: "/:pathMatch(.*)*",
            name: "NotFound",
            component: () => import("../views/NotFound.vue"),
        },
    ],
});

router.beforeEach(async (to) => {
    if (!getAuth().currentUser) {
        return true;
    }

    if (!onboardingProgress.isLoaded) {
        await loadOnboardingProgressFromBackend();
    }

    const isOnboardingPath = to.path === "/onboarding";

    if (!isOnboardingEnabled()) {
        if (isOnboardingPath) {
            return "/";
        }

        return true;
    }

    if (!isOnboardingInProgress()) {
        return true;
    }

    // Allow /open-items when OPEN_ITEMS is the current step
    if (onboardingProgress.currentStepCode === "OPEN_ITEMS") {
        if (to.path === "/open-items" || isOnboardingPath) {
            return true;
        }
        return "/open-items";
    }

    const currentStepPath = getCurrentStepRoutePath();

    if (!currentStepPath) {
        if (!isOnboardingPath) {
            return "/onboarding";
        }

        return true;
    }

    const isCurrentStepPath =
        to.path === currentStepPath.pathname &&
        (to.query["config-tab"] as string | undefined) ===
            currentStepPath.searchParams.get("config-tab");

    if (!isOnboardingPath && !isCurrentStepPath) {
        return "/onboarding";
    }

    return true;
});
